// extracted by mini-css-extract-plugin
module.exports = {"member-page":"style_member-page__2gB0m","icon":"style_icon__7xzbp","member-title":"style_member-title__2-_Xp","member-name":"style_member-name__1hzQW"};